import { lazyLoadImages, lazyLoadBackgroundImages } from './modules/lazyload.js'
// import Mmenu from 'mmenu-js'

// page animations
document.addEventListener('DOMContentLoaded', () => {
  // vars
  const html = document.querySelector('html')
  const anchors = document.getElementsByTagName('a')

  // html classes
  html.classList.remove('is-loading')
  html.classList.add('is-loaded')

  for (let idx=0; idx<anchors.length; idx+=1) {
    // if not a file download
    if(anchors[idx].hasAttribute('download')) {
      console.log(anchors[idx].hostname)
      // fix some stuff here
      if (anchors[idx].hostname === window.location.hostname) {
        anchors[idx].href = anchors[idx].dataset.path
      }
    } else {

      if (anchors[idx].hostname !== window.location.hostname ||
          anchors[idx].pathname === window.location.pathname) {
          continue;
      }    

      anchors[idx].addEventListener('click', function(e) {
        // kill if opening in new tab
        if (e.metaKey || e.ctrlKey) return

        e.preventDefault()

        html.classList.add('is-unloading')
        setTimeout( () => {
          window.location = this.href
        }, 260)

      })
    }
  }
})

// lazy load images
lazyLoadImages()
lazyLoadBackgroundImages()

// mobile nav
document.addEventListener(
  "DOMContentLoaded", () => {
    const hamburger = document.querySelector('.hamburger')
    const menu = new Mmenu('#mobile-menu', {
      'extensions': [
        'pagedim-black'
      ],
      'iconPanels': true,
    })
    const api = menu.API

    api.bind( "close:before", () => {
        hamburger.classList.remove('is-active')
      }
    )

    hamburger.addEventListener('click', (event) => {
        hamburger.classList.add('is-active')
        api.open()
      }
    )
  }
)

// filter navigation
// const getFilter = getUrlVars()["filter"]
// console.log(getFilter)
// if (getFilter) {
//   const nav = document.querySelectorAll('[data-filter]')
//   nav.forEach( el => {
//     getFilter === el.dataset.filter ? el.classList.add('is-active') : el.classList.remove('is-active')
//   })
// }

// function getUrlVars() {
//   const vars = {}
//   const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
//       vars[key] = value
//   })
//   return vars
// }